import { ProfileUpdateDate } from '@components/ProfileUpdateDate'

import { DelegatesEventsInfo } from '../DelegatesEventsInfo'
import { ProfileDelegateEventsContainer, ProfileHeaderDate } from './index.styles'

export const EventInfo = (props: {
  isDelegate?: boolean
  updatedAt?: string
  companyId?: number
  delegatesCount?: number
  futureEventsCount?: number
  pastEventsCount?: number
}) => {
  const { isDelegate, companyId, delegatesCount, futureEventsCount, pastEventsCount, updatedAt = '' } = props

  return (
    <ProfileHeaderDate data-testid="profile_event_info">
      {!!updatedAt && <ProfileUpdateDate updatedAt={updatedAt} />}
      <ProfileDelegateEventsContainer $showBorder={!!updatedAt}>
        <DelegatesEventsInfo
          companyId={companyId}
          futureEventsCount={futureEventsCount}
          pastEventsCount={pastEventsCount}
          delegatesCount={delegatesCount}
          isDelegate={isDelegate}
        />
      </ProfileDelegateEventsContainer>
    </ProfileHeaderDate>
  )
}
